import { useState, useMemo } from 'react';
import { Flex, TextField, Text } from '@radix-ui/themes';
import { useTranslation } from 'react-i18next';
import styles from './manage_categories.module.css';

const ICONS = [
  { name: 'folder', class: 'fa-folder' },
  { name: 'heart pulse', class: 'fa-heart-pulse' },
  { name: 'piggy bank', class: 'fa-piggy-bank' },
  { name: 'shield', class: 'fa-shield-halved' },
  { name: 'circle plus', class: 'fa-circle-plus' },
  { name: 'brain', class: 'fa-brain' },
  { name: 'id card', class: 'fa-id-card' },
  { name: 'spa', class: 'fa-spa' },
  { name: 'people roof', class: 'fa-people-roof' },
  { name: 'house', class: 'fa-house' },
  { name: 'briefcase', class: 'fa-briefcase' },
  { name: 'graduation cap', class: 'fa-graduation-cap' },
  { name: 'stethoscope', class: 'fa-stethoscope' },
  { name: 'tooth', class: 'fa-tooth' },
  { name: 'eye', class: 'fa-eye' },
  { name: 'car', class: 'fa-car' },
  { name: 'plane', class: 'fa-plane' },
  { name: 'gift', class: 'fa-gift' },
  { name: 'hand holding dollar', class: 'fa-hand-holding-dollar' },
  { name: 'coins', class: 'fa-coins' },
  { name: 'chart line', class: 'fa-chart-line' },
  { name: 'baby', class: 'fa-baby' },
  { name: 'wheelchair', class: 'fa-wheelchair' },
  { name: 'dumbbell', class: 'fa-dumbbell' },
  { name: 'apple', class: 'fa-apple-whole' },
  { name: 'book', class: 'fa-book' },
  { name: 'file', class: 'fa-file' },
  { name: 'star', class: 'fa-star' },
  { name: 'users', class: 'fa-users' },
  { name: 'building', class: 'fa-building' },
  { name: 'calendar', class: 'fa-calendar' },
  { name: 'clock', class: 'fa-clock' },
  { name: 'laptop', class: 'fa-laptop' },
  { name: 'lightbulb', class: 'fa-lightbulb' },
  { name: 'umbrella', class: 'fa-umbrella' },
  { name: 'scale balanced', class: 'fa-scale-balanced' },
];

export const IconPicker = ({ selectedIcon, onSelectIcon }) => {
  const { t } = useTranslation('vault');
  const [search, setSearch] = useState('');

  const filteredIcons = useMemo(() => {
    if (!search.trim()) return ICONS;
    const term = search.toLowerCase();
    return ICONS.filter(icon => icon.name.includes(term));
  }, [search]);

  return (
    <Flex direction="column" gap="2">
      <TextField.Root
        size="1"
        placeholder={t('searchIcons')}
        value={search}
        onChange={e => setSearch(e.target.value)}
      >
        <TextField.Slot>
          <i
            className="fa-solid fa-magnifying-glass"
            style={{ fontSize: 12 }}
          />
        </TextField.Slot>
      </TextField.Root>

      <div className={styles.iconGrid}>
        {filteredIcons.map(icon => (
          <button
            key={icon.class}
            type="button"
            className={`${styles.iconButton} ${
              selectedIcon === icon.class ? styles.iconButtonSelected : ''
            }`}
            onClick={() => onSelectIcon(icon.class)}
            title={icon.name}
          >
            <i className={`fa-regular ${icon.class}`} />
          </button>
        ))}
        {filteredIcons.length === 0 && (
          <Text size="1" color="gray">
            {t('noIconsFound')}
          </Text>
        )}
      </div>
    </Flex>
  );
};
